import React, { useState } from 'react';
import "../styles/login.css";
import Layout from '../components/Layout/Layout';
import { toast, Toaster } from 'react-hot-toast'; // Importing toast for success/error messages
import { Link, useNavigate } from 'react-router-dom';


const Login = () => {



  const navigate = useNavigate();




  // State for storing the form data
  const [formData, setFormData] = useState({
    emailOrPhone: '',
    password: '',
  });


  const navigateToLogin = () => {
    navigate('/login'); // Redirect to signup page
  }



  // Handle input changes and update state
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { emailOrPhone, password } = formData;

    // Basic validation before submitting
    if (!emailOrPhone || !password) {
      toast.error('Please fill in all fields');
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_MODE === 'development' ? "http://localhost:8000/api/v1" : `${process.env.REACT_APP_API_URL}`}/auth/login`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ emailOrPhone, password }), // Sending the form data
        });

      const result = await response.json();

      if (response.ok) {
        // If login is successful, save the token in the cookie
        document.cookie = `token=${result.token}; path=/; max-age=87400`; // 24 hour expiration
        document.cookie = `user=${(result.userId)}; path=/; max-age=87400`; // Save user info in cookie
        toast.success('Login successful');

        // You can redirect the user or handle post-login logic here (e.g., setting user token or navigation)
        // For example, redirect to a dashboard:
        window.location.href = '/';
      } else {
        toast.error(result.message || 'Login failed');
      }
    } catch (error) {
      console.error('Error during login:', error);
      toast.error('An error occurred, please try again later');
    }
  };

  return (
    <Layout title={"Lastbites: Login"} children={undefined} description={undefined} keywords={undefined} author={undefined}>
      <main className="login">
        <div className="wrapper">
          <div className="title">
            <span>Login Form</span>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <i className="fas fa-user" />
              <input
                type="text"
                placeholder="Email or Phone"

                name="emailOrPhone"
                value={formData.emailOrPhone}
                onChange={handleInputChange}
              />
            </div>
            <div className="row">
              <i className="fas fa-lock" />
              <input
                type="password"
                placeholder="Password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />
            </div>
            <div className="pass">
              <Link to={"/forget-password"}>Forgot password?</Link>
            </div>
            <div className="row button">
              <input type="submit" value="Login" />
            </div>
            <div className="signup-link">
              Not a member? <Link to={"/register"} className="cursor-pointer">Signup now</Link>
            </div>
          </form>
        </div>
      </main>

      {/* Toast container for success/error messages */}
      <Toaster position="top-center" reverseOrder={false} />
    </Layout>
  );
};

export default Login;
